import React, { useEffect } from 'react';
import CustomerSelect from '../../../CustomerSelect/Facelift';
import { ICustomer } from '../../../../store/ducks/customers/types';
import { ILongSteelOrdersState } from '../../../../store/ducks/long-steel-orders/types';
import { InvoicesState } from '../../../../store/ducks/invoices/types';

interface IShipToViewProps {
  orderOrInvoiceState: ILongSteelOrdersState | InvoicesState;
  isUserAdmin: boolean;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
  receiverId: string;
  setReceiverId(receiverId: string): void;
  customers: ICustomer[];
}

const ShipToView: React.FC<IShipToViewProps> = ({
  orderOrInvoiceState,
  receiverId,
  setReceiverId,
  customers
}) => {
  useEffect(() => {
    if (customers.length === 1 && !receiverId) {
      setReceiverId(customers[0].customerId);
    }
  });

  return (
    <>
      <CustomerSelect
        title={'Recebedor do pedido'}
        placeholder="Selecionar recebedor"
        disabled={orderOrInvoiceState.loading}
        customers={customers}
        onSelect={(customerId) => setReceiverId(customerId)}
        selectedCustomerId={receiverId}
        customStyles={{ selectTitleFontSize: '0.8rem' }}
      />
    </>
  );
};

export default ShipToView;
